import { useNavigate } from 'react-router-dom';

const Logo = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline',
        cursor: 'pointer',
      }}
      onClick={() => navigate('/')}
    >
      <span
        style={{
          fontSize: '1.75rem',
          fontFamily: 'var(--font-display)',
          fontWeight: 400,
          color: 'var(--primary)',
          letterSpacing: '-0.02em',
        }}
      >
        Earmark
      </span>
      <span
        style={{
          fontSize: '1.1rem',
          fontFamily: 'var(--font-display)',
          fontWeight: 400,
          color: 'var(--primary-soft)',
          marginLeft: '1px',
        }}
      >
        .fm
      </span>
    </div>
  );
};

export default Logo;
